export default __webpack_public_path__ + "static/media/gameWin.ad5079ac.mp3";